import Style from "./KeyServiceCard.module.scss";

const KeyServiceCardSkeleton = () => {
  return (
    <div className={`${Style.service_card} ${Style.skeleton}`}>
      <div className={`${Style.service_icon} ${Style.skeleton_shimmer}`}>
        <div className={Style.skeleton_icon}></div>
      </div>
      <div className={`${Style.service_title} ${Style.skeleton_shimmer}`}>
        <div className={Style.skeleton_text}></div>
      </div>
      <div className={`${Style.service_btn} ${Style.skeleton_shimmer}`}>
        <div className={Style.skeleton_button}></div>
      </div>
    </div>
  );
};

export default KeyServiceCardSkeleton;